<script lang="ts" setup>
</script>

<template>
  <router-view />
</template>